import { Avatar } from '@fluentui/react-components'
import iconSquare from '@/assets/brand/icon-square.jpeg'
import { useUserProfile } from '@/app/UserProfileContext'
import type { ChatMessage } from '@/types/chat'
import { MarkdownRenderer } from './MarkdownRenderer'
import styles from './MessageBubble.module.css'

interface MessageBubbleProps {
  message: ChatMessage
}

function formatTime(date: Date): string {
  return date.toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' })
}

export function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === 'user'
  const { firstName, displayName, photoUrl } = useUserProfile()

  const userLabel = firstName || displayName || 'Tu'

  return (
    <div className={`${styles.row} ${isUser ? styles.rowUser : ''}`}>
      {!isUser && (
        <img src={iconSquare} alt="" className={styles.agentAvatar} />
      )}
      <div className={`${styles.bubble} ${isUser ? styles.user : styles.agent}`}>
        <div className={styles.meta}>
          {isUser && <span className={styles.author}>{userLabel}</span>}
          <span className={styles.time}>{formatTime(message.timestamp)}</span>
        </div>
        {message.pending ? (
          <span className={styles.typing} aria-label="SOC-Copilot scrie…">
            <span />
            <span />
            <span />
          </span>
        ) : isUser ? (
          <p className={styles.plainText}>{message.text}</p>
        ) : (
          <MarkdownRenderer content={message.text} />
        )}
      </div>
      {isUser && (
        <Avatar
          name={displayName || userLabel}
          image={photoUrl ? { src: photoUrl } : undefined}
          size={28}
          color="colorful"
          className={styles.userAvatar}
        />
      )}
    </div>
  )
}
